export default __webpack_public_path__ + "static/media/logo_tentamus_white.d4571277.png";